import { UserInput } from 'src/actuators/user-input/types.ts';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations.ts';
import { prepareUserInputFormValues } from 'src/actuators/common/prepareUserInputFormValues.ts';
import { DesignRow } from 'src/modules/common/hooks/buildDesignDataContent.ts';

export const buildDesignDataContentRaw = (props : {
    userInput: UserInput;
    currentRegion: RegionsEnum;
    currentLocale: LocalesEnum;
    isLinear: boolean;
}): DesignRow[] => {
    const rows = prepareUserInputFormValues(props);
    return rows.reduce((acc, [key, val, unit], currentIndex) => {
        acc.push(key);
        acc.push(' ');
        acc.push(val);
        if (typeof unit !== 'string') {
            acc.push(' ');
            acc.push(unit);
        }
        if (currentIndex !== rows.length - 1) {
            acc.push(', ');
        }
        return acc;
    }, [] as DesignRow[]);
};
